import { useState, useCallback, useEffect } from 'react'
import { SellerQueueItem } from '../types'
import { getQueueByPluginspace, getQueueByStatus, getNextAvailable } from '../services'

export const useSellerQueue = (pluginspaceId: number) => {
  const [queue, setQueue] = useState<SellerQueueItem[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [nextAvailable, setNextAvailable] = useState<SellerQueueItem | null>(null)

  const loadQueue = useCallback(async () => {
    console.log('[useSellerQueue] loadQueue - Starting to load queue')
    try {
      setLoading(true)
      setError(null)
      
      console.log('[useSellerQueue] loadQueue - Calling getQueueByPluginspace...')
      const data = await getQueueByPluginspace()
      
      console.log('[useSellerQueue] loadQueue - Got response with', data.length, 'items')
      console.log('[useSellerQueue] loadQueue - Sample items:', data.slice(0, 2).map((i: any) => ({ sellerId: i.sellerId, sellerName: i.sellerName, userName: i.user?.name, position: i.position })))
      setQueue(data)
      console.log('[useSellerQueue] loadQueue - Called setQueue, queue state should be updated')
      
      setLoading(false)
      return data
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : 'Erro ao carregar fila'
      console.error('[useSellerQueue] loadQueue - ERROR:', err)
      setError(errorMsg)
      setQueue([])
      setLoading(false)
      return []
    }
  }, [])

  const loadNextAvailable = useCallback(async () => {
    try {
      const data = await getNextAvailable()
      setNextAvailable(data)
    } catch (err) {
      console.error(err)
    }
  }, [])

  const loadQueueByStatus = useCallback(async (status: string) => {
    try {
      setLoading(true)
      setError(null)
      const data = await getQueueByStatus(status)
      setQueue(data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao filtrar fila')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (pluginspaceId !== undefined && pluginspaceId !== null) {
      loadQueue()
      loadNextAvailable()
    }
  }, [pluginspaceId, loadQueue, loadNextAvailable])

  useEffect(() => {
    const handleSellerQueueUpdated = (event: Event) => {
      const customEvent = event as CustomEvent<{ pluginspaceId?: number }>
      const eventPluginspaceId = Number(customEvent.detail?.pluginspaceId)

      if (!pluginspaceId || eventPluginspaceId !== Number(pluginspaceId)) return

      loadQueue()
      loadNextAvailable()
    }

    window.addEventListener('seller-queue-updated', handleSellerQueueUpdated)

    return () => {
      window.removeEventListener('seller-queue-updated', handleSellerQueueUpdated)
    }
  }, [pluginspaceId, loadQueue, loadNextAvailable])

  return {
    queue,
    loading,
    error,
    nextAvailable,
    loadQueue,
    loadQueueByStatus,
    loadNextAvailable,
  }
}
